export enum EscalationStatus {
  PendingReview = "pending-review",
  Approved = "approved",
  Denied = "denied",
  Active = "active",
  Revoked = "revoked",
  Complete = "complete",
}
